import { render } from "./PanelAdminFAQCreate.vue?vue&type=template&id=72804f9b&scoped=true&ts=true"
import script from "./PanelAdminFAQCreate.vue?vue&type=script&lang=ts"
export * from "./PanelAdminFAQCreate.vue?vue&type=script&lang=ts"

import "./PanelAdminFAQCreate.vue?vue&type=style&index=0&id=72804f9b&lang=scss&scoped=true"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72804f9b"]])

export default __exports__